import { ContactListTab } from 'legacy/lut/components/widgets/public/partnerContacts/components/contactListTab/ContactListTab'
import { useSelector } from 'react-redux'

import { selectRouteParams } from 'core-components/sitebuilder/store/selectors/selectRouteParams'

import { COLUMNS, IGNORED_FIELDS } from '../allContactsTab/configs'

import { useNewContactSource } from './hooks/useNewContactSource'
import { INewContactTabProps } from './models'

export const NewContactTab = (props: INewContactTabProps) => {
  const routeParams = useSelector(selectRouteParams)

  const isPartner360Page = routeParams.page === 'jbl-hpscoutso'
  return (
    <ContactListTab
      {...props}
      useSource={useNewContactSource}
      columns={COLUMNS}
      ignoredFields={IGNORED_FIELDS}
      isPartner360Page={isPartner360Page}
    />
  )
}
